import React from 'react';
import Badge from './Badge';
import { useLanguage } from '../i18n/LanguageContext';
import { useHomeT } from '../i18n/strings';
import { localizeItem } from '../data/portfolio';

export default function ProjectCard({ item, onOpen }) {
  const { lang } = useLanguage();
  const t = useHomeT(lang);
  const d = localizeItem(item, lang);

  const badgeLabel =
    {
      Product: t.badgeProduct,
      Platform: t.badgePlatform,
      Mobile: t.badgeMobile,
      Collaboration: t.badgeCollab,
      Wip: t.badgeWip,
    }[d.kind] || d.kind;

  const handleClick = () => onOpen(item.key);

  const stop = (e) => e.stopPropagation();

  return (
    <button
      type="button"
      className={`gdwd-card${d.dashed ? ' gdwd-card--dashed' : ''}`}
      onClick={handleClick}
    >
      {d.src ? (
        <div className={`gdwd-card__media${d.fit === 'contain' ? ' gdwd-card__media--contain' : ''}`}>
          <img src={d.src} alt="" loading="lazy" />
        </div>
      ) : d.panelImg ? (
        <div className="gdwd-card__media" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
          <img src={d.panelImg} alt="" style={{ maxHeight: 72, objectFit: 'contain' }} loading="lazy" />
        </div>
      ) : d.dashed ? (
        <div className="gdwd-map-illu" style={{ marginBottom: 16 }} aria-hidden>
          <div className="gdwd-map-illu__field" style={{ left: '12%', top: '28%', width: '38%', height: '32%', transform: 'rotate(-8deg)' }} />
          <div className="gdwd-map-illu__field" style={{ left: '48%', top: '18%', width: '34%', height: '40%', transform: 'rotate(6deg)' }} />
          <div className="gdwd-map-illu__field" style={{ left: '28%', top: '52%', width: '42%', height: '28%', transform: 'rotate(3deg)' }} />
        </div>
      ) : null}
      <div className="gdwd-card__body">
        <div className="gdwd-card__meta">
          <Badge kind={d.kind}>{badgeLabel}</Badge>
          {d.note ? <span className="gdwd-note">{d.note}</span> : null}
          {(d.gallery || []).length > 1 ? (
            <span className="gdwd-note">{(d.gallery || []).length} photos</span>
          ) : null}
        </div>
        <h3 className="gdwd-card__title">{d.title}</h3>
        <p className="gdwd-card__blurb">{d.blurb}</p>
        {(d.metric || d.techStack.length) ? (
          <div className="gdwd-card__evidence">
            {d.metric ? (
              <div className="gdwd-card__metric">
                <strong>{d.metric.value}</strong> {d.metric.label}
              </div>
            ) : null}
            {d.techStack.length ? (
              <div className="gdwd-card__stack">{d.techStack.slice(0, 3).join(' · ')}</div>
            ) : null}
          </div>
        ) : null}
        <div className="gdwd-card__foot">
          <div className="gdwd-chips">
            {d.chips.slice(0, 3).map((c) => (
              <span className="gdwd-chip" key={c}>
                {c}
              </span>
            ))}
          </div>
          {d.url ? (
            <a className="gdwd-card__cta" href={d.url} target="_blank" rel="noopener noreferrer" onClick={stop}>
              {d.cta} →
            </a>
          ) : d.cta ? (
            <span className={`gdwd-card__cta${d.ctaMuted ? ' gdwd-card__cta--muted' : ''}`}>{d.cta} →</span>
          ) : (
            <span className="gdwd-card__cta">{t.details} →</span>
          )}
        </div>
      </div>
    </button>
  );
}
